export const StoreScheduleEntryType: {
    AVAILABLE: 'AVAILABLE',
    BLOCKED: 'BLOCKED',
} = {
    AVAILABLE: 'AVAILABLE',
    BLOCKED: 'BLOCKED',
};

export type StoreScheduleEntryType = (typeof StoreScheduleEntryType)[keyof typeof StoreScheduleEntryType]